import React, { PropTypes, Component } from 'react';

import 'styles/hero.scss';

import SubscribeForm from 'components/Forms/Subscribe';
import Bio from './Bio';
import Headline from './Headline';

class Hero extends Component {
    render() {
        return (
            <div className="container">
              <div className="section hero">
                <Bio />
                <div className="call-to-action">
                  <Headline />
                  <div className="form">
                    <div className="form-header">
                      <p>
                        Contact me today for a free consultation
                      </p>
                    </div>
                    <div className="form-body">
                      <div>
                        <SubscribeForm />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        );
    }
}

export default Hero;



/** WEBPACK FOOTER **
 ** ./src/components/LandingPage/Hero/index.js
 **/